import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { LoginComponent } from './shared/account/login/login.component';
import { RegisterComponent } from './shared/account/register/register.component';
import { PaymentComponent } from './shared/account/payment/payment.component';
import { ResetPasswordComponent } from './shared/account/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './shared/account/forgot-password/forgot-password.component';

import { InViewDirective } from './directives/in-view.directive';
import { VideoModalContainerComponent } from './shared/video-modal-container/video-modal-container.component';
import { GoogleSigninDirective } from './directives/google-signin.directive';
import { RequestComponent } from './shared/request/request.component';
import { TermsConditionsComponent } from './shared/terms-conditions/terms-conditions.component';

@NgModule({
  declarations: [
    InViewDirective,
    LoginComponent,
    RegisterComponent,
    PaymentComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    VideoModalContainerComponent,
    GoogleSigninDirective,
    RequestComponent,
    TermsConditionsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    InViewDirective,
    LoginComponent,
    RegisterComponent,
    PaymentComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    VideoModalContainerComponent,
  ]
})
export class CoreModule { }
